/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_ChangeInputs */

const en_fix_change = /** @type {(inputs: Fix_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const de_fix_change = /** @type {(inputs: Fix_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändern`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {Fix_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_change = /** @type {((inputs?: Fix_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_change(inputs)
	return en_fix_change(inputs)
});